var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.svgClassName,attrs:{"aria-hidden":"true","title":" 11"}},[_c('use',{attrs:{"xlink:href":_vm.svgIcon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }